<!-- 提现款操作 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'"
                        :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                        @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <div v-if="scope.index == 0 && scope.row">
                                    <el-form class="baseForm" id="mainInfo" label-width="100px" :model="sendDataInfo"
                                        ref="sendDataInfo" size="mini" :show-message="false" :inline-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <el-form-item v-if="formOneValue.isShow == 1"
                                                v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey" :label="formOneValue.showField"
                                                :prop="formOneValue.entityField"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, message: formOneValue.showField + '不能为空', trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                    v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item"
                                                    :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                    effect="dark"
                                                    :content="String(sendDataInfo[formOneValue.entityField]||'')"
                                                    placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]"
                                                        :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                        @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                        :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                        <el-button
                                                            @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                            slot="append" icon="el-icon-search"
                                                            :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-select clearable size="mini"
                                                    v-else-if="formOneValue.fieldType == 'formatter'"
                                                    :disabled="formOneValue.isChange == 0" @visible-change="selectChange"
                                                    v-model="sendDataInfo[formOneValue.entityField]"
                                                    placeholder="请选择">
                                                    <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)"
                                                        :key="matItem.key"
                                                        :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                                        :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key">
                                                    </el-option>
                                                </el-select>
                                                <el-date-picker v-else-if="formOneValue.fieldType == 'date'"
                                                    v-model="sendDataInfo[formOneValue.entityField]" type="date"
                                                    placeholder="选择日期" format="yyyy-MM-dd" value-format="timestamp"
                                                    :isdisabled="formOneValue.isChange == 0">
                                                </el-date-picker>
                                                <el-input v-else-if="formOneValue.entityField == 'withdrawMoney'"
                                                    @input="setMoney(scope.row.jurconfigform)"
                                                    @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                    :disabled="formOneValue.isChange == 0"
                                                    v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                <el-input v-else class="form_codition" type="text"
                                                    @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                    v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                    :maxlength="$store.state.inputLength"
                                                    :disabled="formOneValue.isChange == 0"></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'"
                                                v-if="formOneValue.isShow == 1"
                                                v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                    v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a
                                                        @click="toDetail(sendDataInfo[formOneValue.riftField])">{{ sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.entityField == 'isWms'">
                                                    {{ sendDataInfo.isWms == 1 ? '是' : '否' }}
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                    </span>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                    {{ getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent) }}
                                                </span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :footFlag="false"
                    :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction"></v-foot>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
                @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
    name: "coWithdrawAction",
    props: ["actionData"],
    components: {
        SearchScheme,
    },
    data() {
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0,
            },
            sendDataInfo: {
                belongName: "",
                bookBalance: '',
                coId: '',
                coName: '',
                obiId: '',
                obiName: '',
                remark: "",
                withdrawMoney: '',
                sxf: ''
            },
            detaislDataInfo: {},
            showTabs: "",
            formDataList: [],
            DialogVisible: false,
            seTitle: "",
            seWidth: "",
            seId: "",
            seType: "",
            seIndex: "",
            sField: "",
            fField: "",
            parentSearchData: {},
            mxHeight: 0,
            tabForm: [],
            mxForm: [],
            footForm: [],
            inputel: [],
            requesUrl: "",
            ruleDisabled: false,
        };
    },
    computed: {},
    watch: {
        'sendDataInfo.coName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.sendDataInfo.coId = ''
                }
            },
            deep: true,
        },
    },
    created() {
        this.imgur();
        this.$nextTick(() => {
            this.openBox();
        });
    },
    methods: {
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
        },
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },
        openSearch(sId, index, type, sField, fField) {
            this.parentSearchData = {};
            if (type == "obiName") {
                if (this.sendDataInfo.coId == "" || this.sendDataInfo.coId == null) {
                    return this.$message({
                        message: "请先选择货主",
                        type: "warning",
                    });
                } else {
                    this.parentSearchData.coId = this.sendDataInfo.coId;
                    this.parentSearchData.coName = this.sendDataInfo.coName;
                }
            }
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            this.$set(this.parentSearchData, type, this.sendDataInfo[type]);
            this.DialogVisible = true;
        },
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                if (val[item] !== undefined) {
                    this.$set(this.sendDataInfo, item, val[item]);
                }
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField);
            });
        },
        changeInputModel(val) {
            this.DialogVisible = false;
            if (val && (val != "" || val != undefined)) {
                this.paramValue(val)
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        nextFocus(index, fField) {
            if (fField == "keydown") {
                return;
            }
            if (index >= (this.inputel.length - 1)) {
                return
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '' && this.inputel[index].disabled == false) {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        sendDataAction(sendDataInfo) {
            this.$refs.sendDataInfo.validate((valid) => {
                if (valid) {
                    const { withdrawMoney, sxf, bookBalance } = this.sendDataInfo;
                    if (NP.plus(+withdrawMoney, +sxf) > +bookBalance) {
                        return this.$message({
                            message: "提现金额不可大于货主余额",
                            type: "error",
                        });
                    }
                    this.sub();
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        async sub() {
            var responseData
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.addCargoownerMoney(this.sendDataInfo);
            } else {
                responseData = await this.$http.updateCargoownerMoney(this.sendDataInfo);
            }

            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
            } else {
                let txtArr = responseData.message.split("<br/>");
                let newArr = [];
                const h = this.$createElement;
                for (const i in txtArr) {
                    newArr.push(h("p", null, txtArr[i]));
                }
                this.$message({
                    message: h("div", null, newArr),
                    type: "error",
                });
            }
        },
        initActionBox(sendDataInfo) {
            this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel", 0);
                    this.init();
                    this.$refs.sendDataInfo.resetFields();
                })
                .catch(() => { });
        },
        setMoney(jurconfigform) {
            const index = jurconfigform.findIndex(item => item.entityField == 'sxf')
            if (index != -1 && jurconfigform[index]) {
                this.$http.feeDeduction({
                    payMoney: this.sendDataInfo.withdrawMoney
                }).then(res => {
                    if (res.status == 200) {
                        this.$set(this.sendDataInfo, 'sxf', res.result)
                    }
                })
            }
        },
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
        },
        initDefaultValue() {
            let arr = this.formDataList[0].jurconfigform
            arr.forEach(item => {
                if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
                    this.sendDataInfo[item.entityField] = item.defaultValue
                }
            })
        },
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.filterMainField();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.initDefaultValue()
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(this.actionData.oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(this.actionData.oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                    this.initFocus();
                }, 16.7);
            });
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'bgiType' || fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                    this.mxForm.forEach((item1) => {
                        if (item1.fieldType == "number") {
                            this.$set(this.detaislDataInfo, item1.entityField, 0);
                        } else if (item1.fieldType == "search" && item1.setField) {
                            var arr = item1.setField.split(",");
                            arr.forEach((item2) => {
                                this.$set(this.detaislDataInfo, item2, "");
                            });
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "");
                        }
                    });

                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].isShowForm = 0
                this.tabForm[i].jurconfigform = [];
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            var arr = [];
            var obj = this.$common.filterMainFields(
                this.formDataList,
                arr,
                mainFormList[0]
            );
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }
        },
    },
    mounted() { },
    beforeCreate() { },
    beforeMount() { },
    beforeUpdate() { },
    updated() {
        this.getMainInput();
    },
    beforeDestroy() { },
    destroyed() { },
    activated() { },
};
</script>

<style scoped>
.table_content_box {
    overflow-y: auto;
}

.baseForm .el-textarea,
.baseForm .el-select,
.baseForm .el-date-editor.el-input,
.baseForm .el-input {
    width: 200px;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}
</style>